/* globals window document $ */

import moment from 'moment';
import trans from '../../../utils/trans';
import toggleClass from '../../../utils/toggleClass';
import http from '../../../utils/http';
import renderWorkoutCard from '../../inventoryOverview/utils/renderWorkoutCard';
import renderWorkoutStructuredData from '../../inventoryOverview/utils/renderWorkoutStructuredData';
import listEvents from './events';
import eventTracker from '../../../components/eventTracker';
import search from '../../../components/eventTracker/dataLayer/search';

const classesList = (element) => {
  const { apiUrlV2, country, cities } = window.appSettings;
  const classesListElement = document.querySelector('[data-js-classesList]');
  const loader = document.querySelector('[data-js-loader]');

  const $element = $(element);

  const limit = 20;
  let currentPage = 1;
  let totalPages = 1;
  let loadingClasses = false;
  let categories = [];
  let locations = [];

  /**
   * constructor function
   */
  function constructor() {
    bindEvents();
  }

  /**
   * bind events with handlers
   */
  function bindEvents() {
    $element.on(listEvents.SCROLL, handleListLoadingScrolling);
    $element.on(listEvents.SET_DATA, handleListUpdate);
  }

  /**
   * handle the listUpdate event
   * @param {Event} event
   * @param {Object} parameters
   */
  function handleListUpdate(event, parameters) {
    if (parameters.categories && parameters.locations) {
      categories = parameters.categories;
      locations = parameters.locations;
      return;
    }

    getClasses(parameters);
  }

  /**
   * check for the filters inputs, date, and all the parameters then make api call to fetch classes
   * @param {Object} parameters
   */
  function getClasses({ page, filtersParams, currentDate }) {
    const data = {
      city: window.selectedCity,
      limit,
      page,
    };

    if (page >= 0) {
      currentPage = page;
    }

    toggleClass(loader, '_is_hidden', false);

    if (filtersParams) {
      Object.keys(filtersParams).forEach((key) => {
        if (filtersParams[key] || key === 'is_digital') {
          data[key] = filtersParams[key];
        }
      });

      if (data.distance) {
        data.radius = data.distance;
        delete data.distance;
      }
    }

    if (page === 1) {
      classesListElement.innerHTML = '';
    }

    if (currentDate) {
      data.start = currentDate;
      data.end = moment(currentDate).endOf('day').toISOString();
    }

    loadingClasses = true;

    http.get(`${apiUrlV2}/workouts/search`, data)
      .then(onWorkoutData)
      .then(res => pushViewToDatalayer(res, filtersParams))
      .catch(() => (loadingClasses = false));
  }

  /**
   * @param {Response} response
   * @param {Object} filters
   */
  function pushViewToDatalayer(response, filters) {
    const categoryIdsArray = filters.category_ids ? filters.category_ids.split(',') : [];
    const selectedCity = cities.find(city => city.city_code === window.selectedCity);
    const categoryNames = categories.length
      ? categories
        .filter(category => categoryIdsArray.includes(category.id.toString()))
        .map(category => category.name)
      : [];

    const partnerIdsArray = filters.partner_ids ? filters.partner_ids.split(',') : [];
    const partnerNames = locations.length
      ? locations
        .filter(location => partnerIdsArray.includes(location.id.toString()))
        .map(location => location.name)
      : [];

    eventTracker.dataLayerPush(search({
      eventName: 'search_executed',
      type: 'class',
      plan: window.selectedProduct,
      city: selectedCity.name.toLowerCase(),
      zipCode: filters.zipcode,
      category: categoryNames,
      time: filters.workout_time,
      location: partnerNames,
      totalCount: response.meta.pagination.total,
      country,
    }));
  }

  /**
   * handle the response and displaying the classes list
   * @param {Object} response
   */
  function onWorkoutData(response) {
    toggleClass(loader, '_is_hidden', true);

    totalPages = response.meta.pagination.total_pages;
    currentPage = response.meta.pagination.current_page;
    loadingClasses = false;

    if (currentPage === 1 && !response.data.length) {
      renderNoWorkoutsContainer();
      return Promise.resolve(response);
    }

    const classesListHTML = [...response.data]
      .reduce((acc, workout) => `${acc}${renderWorkoutCard(workout)}`, '');

    const scriptsHTML = [...response.data]
      .reduce((acc, workout) => `${acc}${renderWorkoutStructuredData(workout)}`, '');

    classesListElement.innerHTML += classesListHTML;
    const workoutsCards = [...element.querySelectorAll('[data-js-workout]')];

    workoutsCards.forEach((workout) => {
      workout.addEventListener('click', handleWorkoutClicked);
    });

    $('body').append(scriptsHTML);

    return Promise.resolve(response);
  }

  /**
   * render no workouts available in case there is no classes
   * @return {String}
   */
  function renderNoWorkoutsContainer() {
    classesListElement.innerHTML = `
      <div class='noClassesWrapper'>
        ${trans('classes.noClasses')}
      </div>
    `;
  }

  /**
   * load the new locations when we reached the middle of the list
   * @param {DOMEvent} event
   * @param {Object} eventData
   */
  function handleListLoadingScrolling(event, { currentDate, filtersParams }) {
    const scrollHeight = $('.classes-page').prop('scrollHeight');
    const scrollPosition = $('.classes-page').height() + $('.classes-page').scrollTop();

    if (!loadingClasses && scrollHeight - scrollPosition <= 100 && currentPage < totalPages) {
      currentPage += 1;
      getClasses({ page: currentPage, currentDate, filtersParams });
    }
  }

  /**
   * handle push conversion event to datalayer, when a workout is clicked
   */
  function handleWorkoutClicked() {
    eventTracker.dataLayerPush(search({
      eventName: 'conversion',
    }));
  }

  constructor();

  return {};
};

export default classesList;



// WEBPACK FOOTER //
// ./resources/assets/js/specifics/classes/list/list.js